import { Vertical } from "gls"
import { isString } from "lodash";
import { ReactNode } from "react";
import { colours } from "styling/colours";
import { style } from "typestyle";

type GroupSectionProps = {
  title?: string | ReactNode;
  children: React.ReactNode;
}
export const GroupSection = (props: GroupSectionProps) => {

  return (
    <Vertical spacing={5}>
      {props.title && isString(props.title)
        ? <span>{props.title}</span>
        : props.title
      }
      <Vertical spacing={5} className={groupStyle}>
        {props.children}
      </Vertical>
    </Vertical>
  )
}

const groupStyle = style({
  marginTop: "10px !important",
  border: `1px solid ${colours.tertiaryText}`,
  padding: "20px"
});